// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","toolbar":"Toolbar_toolbar__3XF19","icon":"Toolbar_icon__hHT67"};